import { createEvent } from 'effector';

export const loginEv = createEvent();

export const setAuthEv = createEvent();

export const getUserInfoEv = createEvent();

export const logoutEv = createEvent();
